/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Account_TitleInputs */

const en_platform_step_account_title = /** @type {(inputs: Platform_Step_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const pl_platform_step_account_title = /** @type {(inputs: Platform_Step_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załóż konto`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Platform_Step_Account_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_account_title = /** @type {((inputs?: Platform_Step_Account_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Account_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_account_title(inputs)
	return en_platform_step_account_title(inputs)
});